"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalize = exports.untokenize = exports.tokenize = void 0;
const difflib_1 = __importDefault(require("difflib"));
function tokenize(s) {
    return s.split(/\s+/);
}
exports.tokenize = tokenize;
function untokenize(ts) {
    return ts.join(' ');
}
exports.untokenize = untokenize;
const equalize = (text, correct) => {
    const aText = tokenize(text);
    const aCorrect = tokenize(correct);
    const resCorrect = [];
    const resText = [];
    let prev = [0, 0, 0];
    const seq = new difflib_1.default.SequenceMatcher(null, aText, aCorrect).getMatchingBlocks();
    for (const match of seq) {
        if (prev[0] + prev[2] !== match[0]) {
            for (let i = prev[0] + prev[2]; i < match[0]; i++) {
                resText.push('_'.repeat(aText[i].length));
            }
            resCorrect.push(...aText.slice(prev[0] + prev[2], match[0]));
        }
        if (prev[1] + prev[2] !== match[1]) {
            for (let i = prev[1] + prev[2]; i < match[1]; i++) {
                resCorrect.push('_'.repeat(aCorrect[i].length));
            }
            resText.push(...aCorrect.slice(prev[1] + prev[2], match[1]));
        }
        resCorrect.push(...aText.slice(match[0], match[0] + match[2]));
        resText.push(...aCorrect.slice(match[1], match[1] + match[2]));
        prev = match;
    }
    return [untokenize(resCorrect), untokenize(resText)];
};
exports.equalize = equalize;
